import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import { iViewGlobal, token } from './plugins'
import 'iview/dist/styles/iview.css'

Vue.use(iViewGlobal)
Vue.use(token)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
